import { ApolloError } from "@apollo/client";
import { t } from "../i18n";
import {message as messageApi} from "antd";

export interface ParseExceptionResult {
    title: string;
    message: string;
}

// 类型守卫函数，用于检查对象是否符合ParseExceptionResult接口
const isParseExceptionResult = (obj: any): obj is ParseExceptionResult => {
    return obj && typeof obj === 'object' && 
           typeof obj.title === 'string' && 
           typeof obj.message === 'string';
};

interface ErrorKeys {
    titleKey: string;
    messageKey: string;
}

export const getErrorKeys = (error?: any): ErrorKeys => {
    if (error instanceof ApolloError && error.graphQLErrors.length > 0) {
        const graphQLError = error.graphQLErrors[0];
        const messageKey = graphQLError.extensions?.messageKey;
        const titleKey = graphQLError.extensions?.titleKey;
        return {
            titleKey: typeof titleKey === 'string' ? titleKey : '',
            messageKey: typeof messageKey === 'string' ? messageKey : ''
        };
    }
    return {
        titleKey: '',
        messageKey: ''
    };
};

export const parseException = (error?: any): ParseExceptionResult => {
    if (error instanceof ApolloError && error.graphQLErrors.length > 0) {
        const graphQLError = error.graphQLErrors[0];
        const details = graphQLError.extensions?.details;

        const titleKey = `${graphQLError.extensions?.messageKey}.title`;
        let title = t(titleKey as string, details);
        if (title === titleKey) {
            title = t('errors.title');
        }

        let messageKey = `${graphQLError.extensions?.messageKey}.message`;
        let message = t(messageKey, details);
        if (message === messageKey) {
            messageKey = `${graphQLError.extensions?.messageKey}`;
            message = t(messageKey, details);
        }
        return { 
            title: title,
            message: message
        }
    }
    return {
        title: t('errors.title'),
        message: t('errors.system.internal')
    }
};


export const showError = (error?: any) => {
    const {title, message} = isParseExceptionResult(error) ? error : parseException(error);
    messageApi.error({
        content: message,
    });
};
